export default __webpack_public_path__ + "static/media/avatar_pyper6.e2855316.mp3";